import { connect } from 'react-redux';

import { STATUSES } from 'legacy/appstore/constants';

import {
  getReportStatusIsRecomputing,
  getReportStatusSharedReportConfigDoesNotExist
} from 'selectors/report-status';
import { getIsReportEditable } from 'selectors/report-permissions';
import { getRentalReportStatus } from 'selectors/rental-report';
import { getReportActiveStatus } from 'selectors/report-data';

import { shareReport } from 'actions/share-report';

import ShareReportButton from 'legacy/components/ShareReportButton';

const mapStateToProps = (state) => {
  let reportStatus = getReportActiveStatus(state);
  // TODO: remove this once status is populated properly in the API response
  if (!reportStatus) {
    reportStatus = 'active';
  }
  const rentalReportStatus = getRentalReportStatus(state);
  return {
    reportStatus,
    disableControls:
      getReportStatusIsRecomputing(state) ||
      rentalReportStatus === STATUSES.INIT ||
      rentalReportStatus === STATUSES.LOADING,
    uniqueLinkDoesNotExist:
      getReportStatusSharedReportConfigDoesNotExist(state),
    isReadOnly: !getIsReportEditable(state)
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleClickShare: () => {
    dispatch(shareReport());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ShareReportButton);
